export default "__VITE_ASSET__6feb4d93__"